import { triggerTracking } from '@zoopla/tracking';
import { TRACKING_EVENT } from '../../constants/tracking';
import { authTaxonomyObject } from '../../constants/taxonomy';

export const trackGoogleOneTapPromptShown = (path: string) =>
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'google_one_tap',
        eventAction: 'module_shown',
        eventLabel: path
    });

export const trackGoogleOneTapPromptClose = (path: string) =>
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'google_one_tap',
        eventAction: 'module_closed',
        eventLabel: path
    });

export const trackGoogleOneTapPromptError = (path: string) =>
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'google_one_tap',
        eventAction: 'failure',
        eventLabel: path
    });

export const trackGoogleOneTapSuccess = (type: string) =>
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: type,
        eventAction: 'success - google',
        eventLabel: 'google_one_tap',
        taxonomy: authTaxonomyObject.google.signin
    });

export const trackGoogleOneTapClose = () =>
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'registration',
        eventAction: 'form closed',
        eventLabel: 'google_one_tap_step_2'
    });
